import { get } from 'lodash';

import months from './../../../enums/months';
import validation from './../../../services/validation';

import template from './available-from.jade';

const dateInFuture = (date, checkDate) => {
  return checkDate.getFullYear() > date.getFullYear() || checkDate.getMonth() >= date.getMonth();
};

export default angular.module('cian.addForm.availableFrom', []).directive('cianAfAboutObjectAvailableFrom', [
  '$timeout',
  $timeout => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    link(scope, element, attr, ctrl) {
      if (ctrl.ad.isOccupied) {
        $timeout(function () {
          ctrl.recalculateDate();
        }, 0);
      }
    },
    controller: [
      '$scope',
      'deviceService',
      function ($scope, deviceService) {
        this.isMobile = deviceService.isMobile;
        const currentDate = new Date();
        const availableFrom = get(this.ad, 'availableFrom', '');
        // Дефолтное значение присвоится только если значение undefined, с null не прокатит, поэтому проверка
        const [sourceYear, sourceMonth] = availableFrom ? availableFrom.split('-') : '';
        const selectedYear = parseInt(sourceYear, 10) || currentDate.getFullYear();
        const selectedMonthValue = parseInt(sourceMonth, 10) - 1 ?? currentDate.getMonth();

        const selectedMonthEnum = months.find(month => month.value === selectedMonthValue);

        this.selectedDate = {
          month: selectedMonthEnum?.viewValue || '01',
          year: selectedYear,
        };

        this.years = [0, 1, 2, 3, 4].map(num => {
          const year = currentDate.getFullYear() + num;

          return { value: year, text: year };
        });
        this.months = months;

        this.monthValidation = validation(this.form, 'availableFromMonth', {
          required: 'Укажите месяц и год, когда помещение освободится',
          invalidDate: 'Дата освобождения не может быть в прошлом',
        });

        this.yearValidation = validation(this.form, 'availableFromYear', {
          required: 'Укажите месяц и год, когда помещение освободится',
          invalidDate: 'Дата освобождения не может быть в прошлом',
        });

        this.isInvalid = () =>
          get(this.form, 'availableFromYear.$invalid') || get(this.form, 'availableFromMonth.$invalid');

        this.recalculateDate = () => {
          if (!this.ad.isOccupied) {
            this.ad.availableFrom = undefined;

            return;
          }
          this.ad.availableFrom = `${this.selectedDate.year}-${this.selectedDate.month}-15T00:00:00+00:00`; // 15 - это середина месяца, что бы исключить влияние таймзоны, наверняка

          const selectedDate = new Date(this.ad.availableFrom);
          const dateIsValid = dateInFuture(currentDate, selectedDate);

          if (!this.form['availableFromMonth']) {
            return;
          }
          this.form['availableFromMonth'].$setValidity('invalidDate', dateIsValid);
          this.form['availableFromYear'].$setValidity('invalidDate', dateIsValid);
        };

        $scope.$watch(
          () => this.ad.isOccupied,
          isOccupied => {
            if (angular.isUndefined(isOccupied)) {
              return;
            }
            this.recalculateDate();
          },
        );
      },
    ],
    controllerAs: 'availableFromCtrl',
    template,
  }),
]).name;
